module.exports = __webpack_public_path__ + "static/media/Experimental_Products_m_mr.caa74226.jpg";